// Documentation for Stamped.io JS API…
// https://help-rewards.stamped.io/article/296-javascript-api
// https://help-rewards.stamped.io/article/661-loyalty-rewards-javascript-events-references

export const StampedIoConfig = {
    launcherLoadedEventName: 'stamped:launcher:loaded',
    earningsWidgetLoadedEventName: 'stamped:widget:rewards-earnings:loaded',
    rewardsRedeemedEventName: 'stamped:rewards:redeemed',
};